'use es6';

export const hasParentWithClass = (el, className) => {
  while (el && el.parentElement) {
    if (el.parentElement.className.includes(className)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};